import { render } from "./gamble.vue?vue&type=template&id=56cb0c23"
import script from "./gamble.vue?vue&type=script&lang=js"
export * from "./gamble.vue?vue&type=script&lang=js"

import "./gamble.vue?vue&type=style&index=0&id=56cb0c23&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__